import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Reproductive Health.
 *
 *   Overview        both programmes side by side
 *   Menstrual Care  cycle tracking
 *   Fertility Care  the fertility journey
 *
 * WHY THIS IS ITS OWN SECTION rather than two more tabs under Care Programmes.
 * These two are the most discrimination-exposed data in the platform:
 * pregnancy and fertility treatment are protected characteristics in every
 * jurisdiction Shoorah operates in, and the underlying records hold cycle
 * phase, flow, sexual activity and pregnancy test results. Splitting the
 * section means a customer can be given the rest of the care reporting without
 * this, and the backend enforces the split at the endpoint rather than trusting
 * the URL.
 *
 * NONE OF THAT UNDERLYING DETAIL IS READ. The pages behind this layout show
 * take-up and check-in activity and nothing else — no cycle information, no
 * journey stage, no test result, not one field beyond a user id and a date.
 *
 * THERE IS NO EMPLOYEES TAB. Being listed here would say that a named employee
 * is trying to conceive, which is precisely the fact this section exists to
 * avoid handing to an employer.
 */
const CompanyReproductiveLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';
  const base = `/${slug}/reproductive-health`;

  const pages = [
    {
      label: 'Overview',
      path: base,
      description: 'Both programmes side by side'
    },
    {
      label: 'Menstrual Care',
      path: `${base}/menstrual`,
      description: 'Cycle tracking — take-up and how often people log'
    },
    {
      label: 'Fertility Care',
      path: `${base}/fertility`,
      description: 'Fertility support — take-up and check-in activity'
    }
  ];

  return (
    <CompanySectionLayout
      title="Reproductive Health"
      subtitle={`How many of your ${population} are using Menstrual Care and Fertility Care, and whether they stay with them. Take-up and engagement only — no cycle, journey or test information is read at all, nobody is named, and groups too small to anonymise are not reported.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyReproductiveLayout;
